import * as types from 'legacy/src/constants/types';

function adminInfo(props) {
  return {
    type: types.SET_ADMIN_INFO,
    ...props,
  };
}

export function setAdminInfo(props) {
  return (dispatch) => {
    dispatch(adminInfo(props));
  };
}
